import './P5Canvas.svelte.css.proxy.js';
/* src/components/P5Canvas.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_element,
	claim_space,
	detach,
	element,
	globals,
	init,
	insert,
	noop,
	query_selector_all,
	safe_not_equal,
	set_style,
	space
} from "../_snowpack/pkg/svelte/internal.js";

const { document: document_1 } = globals;
import { onMount, onDestroy } from "../_snowpack/pkg/svelte.js";

function create_fragment(ctx) {
	let script;
	let script_src_value;
	let t;
	let div;

	return {
		c() {
			script = element("script");
			t = space();
			div = element("div");
			this.h();
		},
		l(nodes) {
			const head_nodes = query_selector_all("[data-svelte=\"svelte-nld0df\"]", document_1.head);
			script = claim_element(head_nodes, "SCRIPT", { src: true });
			var script_nodes = children(script);
			script_nodes.forEach(detach);
			head_nodes.forEach(detach);
			t = claim_space(nodes);
			div = claim_element(nodes, "DIV", { id: true, style: true, class: true });
			children(div).forEach(detach);
			this.h();
		},
		h() {
			if (script.src !== (script_src_value = "/content/blog/js/p5." + /*p5Version*/ ctx[1] + ".min.js")) attr(script, "src", script_src_value);
			attr(div, "id", /*id*/ ctx[0]);
			set_style(div, "position", "relative");
			set_style(div, "width", /*width*/ ctx[2]);
			set_style(div, "height", /*height*/ ctx[3]);
			attr(div, "class", "svelte-3yvr6x");
		},
		m(target, anchor) {
			append(document_1.head, script);
			insert(target, t, anchor);
			insert(target, div, anchor);
		},
		p(ctx, [dirty]) {
			if (dirty & /*p5Version*/ 2 && script.src !== (script_src_value = "/content/blog/js/p5." + /*p5Version*/ ctx[1] + ".min.js")) {
				attr(script, "src", script_src_value);
			}

			if (dirty & /*id*/ 1) {
				attr(div, "id", /*id*/ ctx[0]);
			}

			if (dirty & /*width*/ 4) {
				set_style(div, "width", /*width*/ ctx[2]);
			}

			if (dirty & /*height*/ 8) {
				set_style(div, "height", /*height*/ ctx[3]);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			detach(script);
			if (detaching) detach(t);
			if (detaching) detach(div);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { sketch } = $$props;
	let { id = "sketchXX" } = $$props;
	let { p5Version = "1.0.0" } = $$props;
	let { width = "100%" } = $$props;
	let { height = "100%" } = $$props;
	let myp5 = null;

	function sketchStarted() {
		var div = document.getElementById(id);

		for (var i = 0; i < div.childNodes.length; i++) {
			var foundCanvas = div.children[i].className == "p5Canvas";

			if (foundCanvas) {
				return true;
			}
		}

		return false;
	}

	function tryStartSketch() {
		try {
			if (p5 && sketch && !sketchStarted()) {
				myp5 = new p5(sketch, id);
			}
		} catch(ex) {
			
		} // catch gracefully
	}

	onMount(() => {
		var interval = setInterval(
			() => {
				tryStartSketch();
				var started = sketchStarted();

				if (started) {
					clearInterval(interval);
				}
			},
			100
		);
	});

	onDestroy(() => {
		if (myp5 != null && myp5.remove) {
			myp5.remove();
		}
	});

	$$self.$$set = $$props => {
		if ("sketch" in $$props) $$invalidate(4, sketch = $$props.sketch);
		if ("id" in $$props) $$invalidate(0, id = $$props.id);
		if ("p5Version" in $$props) $$invalidate(1, p5Version = $$props.p5Version);
		if ("width" in $$props) $$invalidate(2, width = $$props.width);
		if ("height" in $$props) $$invalidate(3, height = $$props.height);
	};

	return [id, p5Version, width, height, sketch];
}

class P5Canvas extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			sketch: 4,
			id: 0,
			p5Version: 1,
			width: 2,
			height: 3
		});
	}
}

export default P5Canvas;
//# sourceMappingURL=P5Canvas.svelte.js.map
